<template>
  <div>
    <el-tabs class="m-b-20">
      <el-tab-pane v-if="hiddenTabs.indexOf('global') === -1" label="Filtres globaux">
        <div class="row flex">
          <div class="col" v-if="hiddenFields.indexOf('name') === -1">
            <label>Nom</label>
            <el-input v-model="form.name"></el-input>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('address_department') === -1">
            <label>Département</label>
            <el-select class="form-control" clearable v-model="form.address_department" filterable
                       placeholder="Choisissez un département">
              <el-option
                v-for="department in departments"
                :key="department.id"
                :label="department.name + ' (' + department.id + ')'"
                :value="department.id">
              </el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('type') === -1">
            <label>Type de fiche</label>
            <el-select class="form-control" clearable v-model="form.type" placeholder="Choisissez un type de fiche">
              <el-option label="Client" value="CLIENT"></el-option>
              <el-option label="Ancien client" value="FORMER_CLIENT"></el-option>
              <el-option label="Prospect" value="PROSPECT"></el-option>
              <el-option label="Prospect Mailing" value="PROSPECT_MAILING"></el-option>
              <el-option label="Prospect Facebook" value="PROSPECT_FACEBOOK"></el-option>
              <el-option label="Grande agence" value="BIG_AGENCY"></el-option>
              <el-option label="Liste noire" value="BLACKLIST"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('job_type') === -1">
            <label>Type de métier</label>
            <el-select class="form-control" clearable v-model="job"
                       placeholder="Choisissez un type de métier">
              <el-option value="Métier de la construction">
                <span style="font-weight: bold;">Métier de la construction</span>
              </el-option>
                <el-option value="Métier de la construction : Constructeur">
                  <span style="padding-left: 20px;">Constructeur</span>
                </el-option>
                <el-option value="Métier de la construction : Bureau d'études">
                  <span style="padding-left: 20px;">Bureau d'études</span>
                </el-option>
                <el-option value="Métier de la construction : Maître d'oeuvre">
                  <span style="padding-left: 20px;">Maître d'oeuvre</span>
                </el-option>
                <el-option value="Métier de la construction : Entreprise du bâtiment">
                  <span style="padding-left: 20px;">Entreprise du bâtiment</span>
                </el-option>
                <el-option value="Métier de la construction : Architecte">
                  <span style="padding-left: 20px;">Architecte</span>
                </el-option>
                <el-option value="Métier de la construction : Promoteur">
                  <span style="padding-left: 20px;">Promoteur</span>
                </el-option>
              <el-option value="Marchand de biens">
                <span style="font-weight: bold">Marchand de biens</span>
              </el-option>
                <el-option value="Marchand de biens : Agence immobilière">
                  <span style="padding-left: 20px;">Agence immobilière</span>
                </el-option>
                <el-option value="Marchand de biens : Lotisseur">
                  <span style="padding-left: 20px;">Lotisseur</span>
                </el-option>
                <el-option value="Marchand de biens : Notaire">
                  <span style="padding-left: 20px;">Notaire</span>
                </el-option>
                <el-option value="Marchand de biens : Mairie">
                  <span style="padding-left: 20px;">Mairie</span>
                </el-option>
                <el-option value="Marchand de biens : Géomètre">
                  <span style="padding-left: 20px;">Géomètre</span>
                </el-option>
              <el-option value="Travaux et rénovation">
                <span style="font-weight: bold;">Travaux et rénovation</span>
              </el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('childrens') === -1">
            <label>Fiche filles</label>
            <el-select class="form-control" clearable v-model="form.childrens">
              <el-option label="Cachées" value="HIDDEN"></el-option>
              <el-option label="Visibles" value="VISIBLE"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('sources') === -1">
            <label>Sur l'interface</label>
            <el-select class="form-control" clearable v-model="form.sources"
                       placeholder="Choisissez l'interface à filtrer">
              <el-option label="Devis B2B" value="devis-b2b"></el-option>
              <el-option label="Communication" value="communication"></el-option>
              <el-option label="Sellsy ComWeb" value="sellsy-comweb"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('user_id') === -1">
            <label>Assigné à</label>
            <el-select class="form-control" clearable v-model="form.user_id" placeholder="Choisissez un commercial">
              <el-option label="Non assigné" value="null"></el-option>
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="user.name"
                :value="user.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hiddenTabs.indexOf('service') === -1" label="Filtres de services">
        <div class="row flex">
          <div class="col" v-if="hiddenFields.indexOf('service_active_on') === -1">
            <label>Service actif sur</label>
            <el-select class="form-control" clearable v-model="form.service_active_on"
                       placeholder="Choisissez la plateforme">
              <el-option v-for="source in sources" :label="source.name" :key="source.id" :value="source.id"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('service_next_expiration_at') === -1">
            <label>Expiration du service</label>
            <div class="row">
              <div class="col-md-6">
                <el-date-picker v-model="form.service_next_expiration_at.from" type="date" class="form-control"
                                placeholder="Date de début"></el-date-picker>
              </div>
              <div class="col-md-6">
                <el-date-picker v-model="form.service_next_expiration_at.to" type="date" class="form-control"
                                placeholder="Date de fin"></el-date-picker>
              </div>
            </div>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('service_no_quotes_since') === -1">
            <label>Aucun devis reçu
              <source-app name="devis-b2b" size="tiny"></source-app>
            </label>
            <el-select class="form-control" clearable v-model="form.service_no_quotes_since"
                       placeholder="Choisissez la date de réception du dernier devis">
              <el-option label="depuis 15 jours" :value="moment().subtract(15, 'day').format('YYYY-MM-DD')"></el-option>
              <el-option label="depuis 1 mois" :value="moment().subtract(1, 'month').format('YYYY-MM-DD')"></el-option>
              <el-option label="depuis 2 mois" :value="moment().subtract(2, 'month').format('YYYY-MM-DD')"></el-option>
              <el-option label="depuis 3 mois" :value="moment().subtract(3, 'month').format('YYYY-MM-DD')"></el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hiddenTabs.indexOf('billing') === -1" label="Filtres de facturation">
        <div class="row flex">
          <div class="col" v-if="hiddenFields.indexOf('billing_invoice_status') === -1">
            <label>
              Etat des factures
            </label>
            {{ form.billing_invoice_status }}
            <el-select class="form-control" clearable v-model="form.billing_invoice_status">
              <el-option label="En retard ou en recouvrement" value="overdue_litigation"></el-option>
              <el-option label="En retard uniquement" value="overdue"></el-option>
              <el-option label="En recouvrement uniquement" value="litigation"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('billing_invoice_count') === -1">
            <label>
              Nombre de facture
            </label>
            <el-select class="form-control" clearable v-model="form.billing_invoice_count">
              <el-option label="Moins de 3" value="-3"></el-option>
              <el-option label="3 et plus" value="+3"></el-option>
            </el-select>
          </div>
          <div class="col" v-if="hiddenFields.indexOf('billing_invoice_amount') === -1">
            <label>
              Total des factures
            </label>
            <el-select class="form-control" clearable v-model="form.billing_invoice_amount">
              <el-option label="Moins de 160 €" value="-160"></el-option>
              <el-option label="160 € à 500 €" value="160-500"></el-option>
              <el-option label="500 € à 1 000 €" value="500-1000"></el-option>
              <el-option label="1 000 € à 2 000 €" value="1000-2000"></el-option>
              <el-option label="Plus de 2 000 €" value="2000-"></el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <p v-if="results >= form.maxResults" style="text-align: center;" class="text-warning">
      <i class="fa fa-warning"></i>
      Seuls les {{ form.maxResults }} premiers resultats sont affichés. Ajoutez des filtres pour ajuster votre sélection.
    </p>
  </div>
</template>

<script>
  import _ from 'lodash'
  import SourceApp from '../SourceApp.vue'

  export default {
    components: {SourceApp},
    name: 'customer-search-form',
    props: ['values', 'watchValues', 'hideFields', 'hideTabs', 'where'],
    data () {
      return {
        hiddenFields: this.hideFields ? this.hideFields : [],
        hiddenTabs: this.hideTabs ? this.hideTabs : [],
        results: 0,
        form: _.merge({
          maxResults: 100,
          name: '',
          type: '',
          job_type: '',
          childrens: 'HIDDEN',
          user_id: '',
          flag_active: '',
          sources: '',
          address_department: '',
          service_active_on: '',
          service_next_expiration_at: {
            from: null,
            to: null
          },
          service_no_quotes_since: '',
          quotation_not_accepted: '',
          billing_invoice_status: '',
          billing_invoice_count: '',
          billing_invoice_amount: ''
        }, this.values)
      }
    },
    computed: {
      job: {
        get: function () {
          if(this.form.job) {overdue_
            return this.form.job_type + ' : ' + this.form.job
          } else if(this.form.job_type) {
            return this.form.job_type
          } else {
            return ''
          }
        },
        set: function (value) {
          if (value.indexOf(' : ') > -1) {
            let temp = value.split(' : ')
            this.form.job_type = temp[0]
            this.form.job = temp[1]
          } else {
            this.form.job = null
            this.form.job_type = value
          }
        }
      },
      users () {
        return this.$store.getters['users/commercials'].filter(user => !user.disabled)
      },
      departments () {
        return this.$store.getters['departments/all']
      },
      sources () {
        return this.$model.source_app.get().filter(source => {
          return source.has.services
        })
      }
    },
    methods: {
      load: _.debounce((self) => {
        let where = {}
        if(self.where) {
          where = self.where
        }

        // Tab 1 : global filters
        if (self.form.type) where.type = self.form.type
        if (self.form.name) where.name_slug = {like: '%' + self.form.name + '%'}
        if (self.form.address_department) where.address_zip_code = {like: self.form.address_department + '%'}
        if (self.form.job_type) where.job_type = self.form.job_type
        if (self.form.childrens === 'HIDDEN') where.parent_id = 'null'
        if (self.form.sources) where.sources = {like: '%' + self.form.sources + '%'}
        if (self.form.user_id) where.user_id = self.form.user_id

        // Tab 2 : service filters
        if (self.form.service_active_on) where.meta_flag_service_active_on = {like: '%' + self.form.service_active_on + '%'}
        if (self.form.service_next_expiration_at.from || self.form.service_next_expiration_at.to) where.meta_flag_service_next_expiration_at = {}
        if (self.form.service_next_expiration_at.from) where.meta_flag_service_next_expiration_at['>='] = self.form.service_next_expiration_at.from
        if (self.form.service_next_expiration_at.to) where.meta_flag_service_next_expiration_at['<='] = self.form.service_next_expiration_at.to
        if (self.form.service_no_quotes_since) where.meta_flag_service_no_quotes_since = {'>=': self.form.service_no_quotes_since}

        // Tab 3 : document filters
        if (self.form.billing_invoice_status) {
          if(self.form.billing_invoice_status === 'overdue_litigation') {
            where.meta_document_flag_late_invoice_count = {'>': 0}
          } else if(self.form.billing_invoice_status === 'overdue') {
            where.meta_document_flag_overdue_invoice_count = {'>': 0}
          } else if(self.form.billing_invoice_status === 'litigation') {
            where.meta_document_flag_litigation_invoice_count = {'>': 0}
          }
        }
        if (self.form.billing_invoice_count) {
          let condition = null
          if(self.form.billing_invoice_count === '-3') {
            condition = {'<': 3}
          } else {
            condition = {'>=': 3}
          }

          if(self.form.billing_invoice_status === 'overdue_litigation') {
            where.meta_document_flag_late_invoice_count = condition
          } else if(self.form.billing_invoice_status === 'overdue') {
            where.meta_document_flag_overdue_invoice_count = condition
          } else if(self.form.billing_invoice_status === 'litigation') {
            where.meta_document_flag_litigation_invoice_count = condition
          }
        }
        if (self.form.billing_invoice_amount) {
          let condition = {}
          let range = self.form.billing_invoice_amount.split('-')
          if(range[0]) {
            condition['>'] = range[0]
          }
          if(range[1]) {
            condition['<'] = range[1]
          }

          if(self.form.billing_invoice_status === 'overdue_litigation') {
            where.meta_document_flag_late_invoice_amount = condition
          } else if(self.form.billing_invoice_status === 'overdue') {
            where.meta_document_flag_overdue_invoice_amount = condition
          } else if(self.form.billing_invoice_status === 'litigation') {
            where.meta_document_flag_litigation_invoice_amount = condition
          }
        }

        self.$emit('loading')
        let params = {where};
        if (self.form.current_page !== undefined) {
          params['page'] = self.form.current_page
          self.$nexus.get('crm2', 'customers', {params}).then(response => {
            self.results = response.data.data.length
            self.$emit('loaded', {form: self.form, customers: response.data.data, pagination: response.data.meta.pagination})
          })
        } else {
          params['limit'] = self.form.maxResults
          self.$nexus.get('crm2', 'customers', {params}).then(response => {
            self.results = response.data.data.length
            self.$emit('loaded', {form: self.form, customers: response.data.data})
          })
        }
      }, 250)
    },
    watch: {
      values: {
        deep: true,
        handler (value) {
          if(this.watchValues) {
            this.form = _.merge(this.form, value)
          }
        }
      },
      form: {
        deep: true,
        handler (value) {
          this.load(this)
        }
      }
    },
    mounted () {
      this.load(this)
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerSearchForm.vue?6482a11c